/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Remove_Day_TitleInputs */

const en_us2_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.session}?`)
};

const pt_br2_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Excluir o ${i?.session}?`)
};

const es_419_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Eliminar ${i?.session}?`)
};

const pt_pt2_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar o ${i?.session}?`)
};

const fr_fr2_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer ${i?.session} ?`)
};

const de_de2_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} löschen?`)
};

const it_it2_plan_build_remove_day_title = /** @type {(inputs: Plan_Build_Remove_Day_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminare ${i?.session}?`)
};

/**
* | output |
* | --- |
* | "Delete {session}?" |
*
* @param {Plan_Build_Remove_Day_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_remove_day_title = /** @type {((inputs: Plan_Build_Remove_Day_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Remove_Day_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_remove_day_title(inputs)
	if (locale === "es-419") return es_419_plan_build_remove_day_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_remove_day_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_remove_day_title(inputs)
	if (locale === "de-DE") return de_de2_plan_build_remove_day_title(inputs)
	if (locale === "it-IT") return it_it2_plan_build_remove_day_title(inputs)
	return en_us2_plan_build_remove_day_title(inputs)
});
export { plan_build_remove_day_title as "plan-build.remove_day_title" }